var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
define('util/pubsub',["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.PubSub = void 0;
    /**
     * Publish/subscribe listeners (used for focus, etc)
     */
    var PubSub = /** @class */ (function () {
        function PubSub() {
            this.listeners = [];
        }
        PubSub.prototype.subscribe = function (listener) {
            this.listeners.push(listener);
        };
        PubSub.prototype.post = function (item) {
            var args = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args[_i - 1] = arguments[_i];
            }
            for (var _a = 0, _b = this.listeners; _a < _b.length; _a++) {
                var listener = _b[_a];
                listener.apply(void 0, __spreadArray([item], args, false));
            }
        };
        return PubSub;
    }());
    exports.PubSub = PubSub;
});
//# sourceMappingURL=/assets/javascripts/util/pubsub.js.map;
